import React, { Component } from 'react';
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import './App.css';

import FlightStatus from './widgets/FlightStatus';
import FareFinder from './widgets/FareFinder';
import NotFound from './NotFound';

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/flightStatus" component={FlightStatus} />
          <Route path="/fare-finder" component={FareFinder} />
          <Route path="/*" component={NotFound} />
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js